<template>
  <DefaultTemplate>
    <DefaultError  :page="'not-allowed'">
      <h1 class="text-grey color-60 pd-t-5">
        ขออภัย คุณไม่มีสิทธิเข้าถึงหน้านี้<br />
        <span class="text-white not-hover cursor-pointer" @click="backPage"
          ><u v-if="pageActive != null">ย้อนกลับ</u></span
        >
      </h1>
    </DefaultError>
  </DefaultTemplate>
</template>
<script>
import DefaultError from "@/template/DefaultError";
import DefaultTemplate from "@/template/DefaultTemplate";
import { mapState } from "vuex";
export default {
  components: {
    DefaultTemplate,
    DefaultError,
  },
  computed: {
    ...mapState({
      pageActive: (state) => state.pageActive,
      permissionNow: (state) => state.permissionNow,
    }),
  },
  methods: {
    backPage() {
      this.$router.push(`/${this.pageActive}`);
    },
  },
};
</script>
